import Form from 'components/form/Form';
import PanelPage from 'navigation/pages/PanelPage';
class OrderTracking extends PanelPage {
    static pageName = 'OrderTracking';
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            form: ['.form', Form]
        };
    }
}
export default OrderTracking;
